import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl  } from '@angular/forms';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AmcService } from 'src/app/_services/amc/amc.service'
import { ActionItemsGridRowRendererComponent } from '../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';


@Component({
  selector: 'app-annual-maintenance-contracts',
  templateUrl: './annual-maintenance-contracts.component.html',
  styleUrls: ['./annual-maintenance-contracts.component.scss']
})
export class AnnualMaintenanceContractsComponent implements OnInit {
  amcForm
  // row data and column definitions  
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any;
   tenantId: string;
    currentUser: any;
    selectedFile: File;
    form: FormGroup;
    emailPattern = "^[a-z0-9._%+-]+\\.[a-z]{2,4}$";
    gridLength = 0;
    sampleGridFrameworkComponents: any;
    selectedCheckboxData = []
    deleteConfirmationMsg = 'Are you sure you want to delete'
    userDropdownList = [];
    getUserName: any;

  constructor(
    private amcService: AmcService,
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };

    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();  

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.amcForm = new FormGroup({
      id: new FormControl(''),
      supplierName: new FormControl('',[Validators.required]),
      servicesProvidedBySupplier: new FormControl(''),
      activityDescription: new FormControl(''),
      servicesBySupplier: new FormControl(''),
      aggrementReference: new FormControl(''),
      contractPeriod: new FormControl(''),
      contractStartDate: new FormControl('',[Validators.required]),
      contractEndDate: new FormControl('',[Validators.required]),
      contractGracePeriod: new FormControl(''),
      slaAgreedByServiceProvider: new FormControl(''),
      frequencyOfReview:  new FormControl(''),
      paymentTermsAndConditions: new FormControl(''),
      accountManagerFromCompany: new FormControl(''),
      accountManagerFromServiceProvider: new FormControl(''),
      serviceSubcontracted: new FormControl(''),
      subcontractDetails: new FormControl(''),
      relationWithSubcontractor: new FormControl(''),
      remark: new FormControl(''),
    })

   }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.getAmcData();
    this.getUserList();
  }

  getAmcData() {
    this.amcService.getAllAnnualMaintenanceContracts().subscribe((response: any) => {
      this.rowData = response.result;
    });  
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }  


  private createColumnDefs() {
    return [
    {
      headerName: 'Supplier Name',
      field: 'supplierName',
      filter: true,
      editable: false,
      sortable: true,
      headerCheckboxSelection: this.isFirstColumn,
      checkboxSelection: this.isFirstColumn,
    },
    {
      headerName: 'Services ProvidedBy Supplier',
      field: 'servicesProvidedBySupplier',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Activity Description',
      field: 'activityDescription',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Services By Supplier',
      field: 'servicesBySupplier',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Aggrement Reference',
      field: 'aggrementReference',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Contract Period',
      field: 'contractPeriod',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Contract Start Date',
      field: 'contractStartDate',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Contract EndDate',
      field: 'contractEndDate',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Contract Grace Period',
      field: 'contractGracePeriod',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'SLA AgreedBy Service Provider',
      field: 'slaAgreedByServiceProvider',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Frequency Of Review',
      field: 'frequencyOfReview',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Payment Terms And Conditions',
      field: 'paymentTermsAndConditions',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Frequency Of Review',
      field: 'frequencyOfReview',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Account Manager From Company',
      field: 'accountManagerFromCompany',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Account Manager From Service Provider',
      field: 'accountManagerFromServiceProvider',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Service Subcontracted',
      field: 'serviceSubcontracted',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Subcontract Details',
      field: 'subcontractDetails',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Relation With Subcontractor',
      field: 'relationWithSubcontractor',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Remark',
      field: 'remark',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
  ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  createAMC() {
    let details = JSON.stringify(this.amcForm.value);
    this.amcService.createAnnualMaintenanceContracts(details).subscribe(response => {
      console.log("response: ", response);
      
      // update grid after creating new lead & close the modal
      this.api.applyTransaction({ add: [response] });
      $('#closeCreateModal').trigger("click");
    });
  }

    // getter for easy access to form fields
    get f() {
      return this.amcForm.controls;
    }

    performGridActionItem(params) {
      if (params.event.currentTarget.value == 'delete') {
        this.deleteGridRow(params);
      }     
    }


    private deleteGridRow(params: any) {
      this.amcService.deleteAnnualMaintenanceContracts(params.params.data.id).subscribe(() => {
        var selectedData = params.params.data;
        this.api.applyTransaction({ remove: [selectedData] });
      });
    }

    editOpenModal() {
      this.modeAction = 2;
      this.amcForm.patchValue(this.selectedCheckboxData[0])
    }

    createOpenModal() {
      this.amcForm.reset();
      this.modeAction = 1;
      this.amcForm.patchValue({
        id: '',
        supplierName: '',
        servicesProvidedBySupplier: '',
        activityDescription: '',
        servicesBySupplier: '',
        aggrementReference: '',
        contractPeriod: '',
        contractStartDate: '',
        contractEndDate: '',
        contractGracePeriod: '',
        slaAgreedByServiceProvider: '',
        frequencyOfReview:  '',
        paymentTermsAndConditions: '',
        accountManagerFromCompany: '',
        accountManagerFromServiceProvider: '',
        serviceSubcontracted: '',
        subcontractDetails: '',
        relationWithSubcontractor: '',
        remark: '',
      })
    }

    updateamc() {
      this.amcService.updateAnnualMaintenanceContracts(this.amcForm.value, this.selectedCheckboxData[0].id).subscribe(res => {
        this.getAmcData();
        this.selectedCheckboxData = []
        $('#closeCreateModal').trigger("click");
      })
    }

    deleteOpenModal() {
      this.deleteConfirmationMsg = 'Are you sure you want to delete'
      for (let i in this.selectedCheckboxData) {
        if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].supplierName}`;
        else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].supplierName}`;
        else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].supplierName}`;
      }
    }

    deleteAmcList() {
      this.amcService.deleteAnnualMaintenanceContracts(this.selectedCheckboxData[0].id).subscribe(() => {
        this.getAmcData();
        this.selectedCheckboxData = []
        $('#closeModalDeleteLead').trigger("click");
      });
    }

    getUserList() {
      this.userDropdownList = [];
      this.allocationService.getUserDetails().subscribe((response) => {
        this.getUserName = response;
        for (let item of response) {
          this.userDropdownList.push(
            `${item.id} ${item.firstName} ${item.lastName}`
          );
        }
      });
    }

}
